export default __webpack_public_path__ + "static/media/hht2_ani_04.ff70c072.png";